import React from "react";
import TimezoneSelectNoGuess from "../Timezone/TimezonesNoGuess";
import Medal from "../Medal/Medal";
import {
  transform_timezone,
  transform_meeting_provider,
} from "../Transformation/Transformations";
import {
  getMedalType,
  getMinutesToNextLevel,
  getNextMedalLevel,
} from "../Medal/Medal";

export default function UserProfileDetailsRegular({
  t,
  isChange,
  parsedUserProfile,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  mail,
  timeZone,
  setTimeZone,
  totalTeachingMinutes,
  totalLearningMinutes,
  availableTeachingMinutesForCertificate,
  availableMoneyToCashOut,
  meetingProvider,
  setMeetingProvider,
  myCredit,
}) {
  return (
    <>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
          {t("user_home.first_name")}:
        </p>
        {isChange === false ? (
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {parsedUserProfile?.first_name}
          </p>
        ) : (
          <input
            type="text"
            className="w-full border-[1px] border-[var(--brand)] bg-[var(--bg)] rounded-md px-3 py-1"
            value={firstName || ""}
            onChange={(e) => setFirstName(e.target.value)}
          />
        )}
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
          {t("user_home.last_name")}:
        </p>
        {isChange === false ? (
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {parsedUserProfile?.last_name}
          </p>
        ) : (
          <input
            type="text"
            className="w-full border-[1px] border-[var(--brand)] bg-[var(--bg)] rounded-md px-3 py-1"
            value={lastName || ""}
            onChange={(e) => setLastName(e.target.value)}
          />
        )}
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
          {t("user_home.email")}:
        </p>
        <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
          {mail}
        </p>
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
          {t("user_home.timezone")}:
        </p>
        {isChange === false ? (
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {t(transform_timezone(parsedUserProfile?.timezone))}
          </p>
        ) : (
          <TimezoneSelectNoGuess
            timeZone={timeZone}
            setTimeZone={setTimeZone}
          />
        )}
      </div>
      <div className="mb-4 flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
            {t("user_home.total_teaching")}:
          </p>
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {totalTeachingMinutes}
          </p>
          {getMedalType(totalTeachingMinutes) && (
            <Medal type={getMedalType(totalTeachingMinutes)} size={32} />
          )}
        </div>
        {getMinutesToNextLevel(totalTeachingMinutes) !== null && (
          <p className="text-xs sm:text-sm text-gray-600 ml-2">
            {getMinutesToNextLevel(totalTeachingMinutes)} minutes needed for{" "}
            {getNextMedalLevel(totalTeachingMinutes)} medal
          </p>
        )}
      </div>
      <div className="mb-4 flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
            {t("user_home.total_learning")}:
          </p>
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {totalLearningMinutes}
          </p>
          {getMedalType(totalLearningMinutes) && (
            <Medal type={getMedalType(totalLearningMinutes)} size={32} />
          )}
        </div>
        {getMinutesToNextLevel(totalLearningMinutes) !== null && (
          <p className="text-xs sm:text-sm text-gray-600 ml-2">
            {getMinutesToNextLevel(totalLearningMinutes)} minutes needed for{" "}
            {getNextMedalLevel(totalLearningMinutes)} medal
          </p>
        )}
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)]">
          {t("user_home.total_certificate")}:
        </p>
        <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
          {availableTeachingMinutesForCertificate}
        </p>
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] whitespace-nowrap">
          {t("user_home.available_cash_out")}:
        </p>
        <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
          {availableMoneyToCashOut}
        </p>
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg sm:leading-5 leading-3 font-medium mb-1 text-[var(--brand)] sm:whitespace-nowrap">
          {t("user_home.meeting_provider")}:
        </p>
        {isChange === false ? (
          <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
            {t(transform_meeting_provider(meetingProvider))}
          </p>
        ) : (
          <select
            type="select"
            className="border-[1px] text-sm sm:text-lg sm:leading-5 border-[var(--brand)] bg-[var(--bg)] w-full rounded-md px-3 py-1"
            value={meetingProvider}
            onChange={(e) => setMeetingProvider(e.target.value)}
          >
            <option value="">{t("user_home.select")}</option>
            <option value="ZOOM">{t("user_home.zoom")}</option>
            <option value="VooV">{t("user_home.voov")}</option>
          </select>
        )}
      </div>
      <div className="mb-4 flex items-center gap-2">
        <p className="text-sm sm:text-lg md:text-xl font-medium text-[var(--brand)]">
          {t("user_home.my_credit")}:
        </p>
        <p className="text-sm sm:text-lg sm:leading-5 text-black whitespace-nowrap">
          {myCredit}
        </p>
      </div>
    </>
  );
}
